/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */
import isNil from 'lodash/isNil';
import orderBy from 'lodash/orderBy';
import {
    DisplayHtmlContent,
    Heading,
    NeedToKnow as NeedToKnowSarsaparilla,
    Stack,
} from 'sarsaparilla';
import type { FormError } from '../../../types/permit';

interface NeedToKnowTypes {
    contents: Array<{
        title: 'selecting-tree' | 'where-to-cut';
        paragraphs: Array<string>;
    }>;
    errors: Record<string, Array<FormError>>;
    isConsentChecked: boolean;
    onChangeConsentHandler: (isChecked: boolean) => void;
}

export default function NeedToKnow({
    contents,
    errors,
    isConsentChecked,
    onChangeConsentHandler,
}: NeedToKnowTypes) {
    const isInvalid = !!errors?.General?.length;

    const headings = {
        'selecting-tree': 'Selecting Your tree',
        'where-to-cut': 'Where to cut your tree',
    };
    const items = orderBy(contents, ['title'], ['desc', 'asc']);

    return (
        <div className="tp-need-to-know">
            <NeedToKnowSarsaparilla
                introText={
                    'Below you will find important information regarding your Christmas tree permit. Please carefully review the important information below and click the check box to agree to all the tips and guidelines when selecting your tree.'
                }
                checkboxId="consent"
                isChecked={isConsentChecked}
                isInvalid={isInvalid}
                onChange={() => {
                    onChangeConsentHandler(!isConsentChecked);
                }}
            >
                <Stack>
                    {items.map(({ title, paragraphs = [] }, i) => {
                        const p = !isNil(paragraphs) ? paragraphs : [];
                        const hasParagraphs = !!p.length;

                        return (
                            <div key={i}>
                                {title && (
                                    <Heading
                                        appearance="h5Caps"
                                        headingLevel={3}
                                        className="mb-2"
                                    >
                                        {headings[title]}
                                    </Heading>
                                )}
                                {hasParagraphs && (
                                    <ul key={i}>
                                        {p.map((html: string, j: number) => {
                                            return (
                                                <li key={`${i}-${j}`}>
                                                    <DisplayHtmlContent html={html} />
                                                </li>
                                            );
                                        })}
                                    </ul>
                                )}
                            </div>
                        );
                    })}
                </Stack>
            </NeedToKnowSarsaparilla>
        </div>
    );
}
